import config from 'SRC/config/config.json'
import { getInitialSpecificationValues } from 'SRC/modules/ads/shared/functions'

export const getInitialValues = ({
	currentSubCategory,
	isAuthorized,
	userInfo,
	specifications,
	hasPriceFromToAddon,
	hasPriceOnRequestAddon,
	hasAdTitleAddon,
	priceTypes
}) => {
	const { adForm: { equipmentGroups, durations, adPriceTypes, swapOptions, conditions } } = config

	const initialValues = {
		title: '',
		description: '',
		duration: durations[3].value,
		listing: 1,
		equipment: equipmentGroups.reduce((acc, curr) => {
			acc[curr.id] = []
			return acc
		}, {}),
		country: config.globalOptions.MontenegroId,
		region: -1,
		city: -1,
		location: -1
	}

	if (hasAdTitleAddon) {
		initialValues.useTitleForCompiledTitle = false
	}

	initialValues.priceType = `${adPriceTypes.negotiated.id}`
	initialValues.price = -1
	initialValues.discountedPrice = -1

	if (hasPriceFromToAddon) {
		initialValues.priceTypeForAddons = `${adPriceTypes.retail.id}`
		initialValues.priceFrom = -1
		initialValues.priceTo = -1
	}

	if (Array.isArray(priceTypes) && priceTypes.length) {
		initialValues.typeOfPrice = -1
	}

	if (hasPriceOnRequestAddon) {
		initialValues.priceOnRequest = false
	}

	initialValues.swapp = swapOptions[0].value
	initialValues.swapps = -1

	initialValues.specifications = getInitialSpecificationValues({ categorySpecifications: specifications, formType: 'addAdDetail' })

	if (currentSubCategory && currentSubCategory.compatibilityCategories && currentSubCategory.compatibilityCategories.length) {
		initialValues.compatibilities = []
		initialValues.compatibilityCategory = -1
		initialValues.compatibilityUniversality = false
	}

	if (userInfo && currentSubCategory && !currentSubCategory.hasShortForm) {
		const userMainAddress = Array.isArray(userInfo.userAddresses) && userInfo.userAddresses.length ? userInfo.userAddresses[0] : null
		if (userMainAddress && userMainAddress.country) {
			initialValues.country = `${userMainAddress.country.id}`
		}
		if (userMainAddress && userMainAddress.region) {
			initialValues.region = `${userMainAddress.region.id}`
		}
		if (userMainAddress && userMainAddress.city) {
			initialValues.city = `${userMainAddress.city.id}`
		}
		if (userMainAddress && userMainAddress.location) {
			initialValues.location = `${userMainAddress.location.id}`
		}
	}

	if (!isAuthorized) {
		initialValues.country = `${config.globalOptions.MontenegroId}`
		initialValues.region = -1
		initialValues.city = -1
		initialValues.location = -1

		initialValues.newUser = {
			name: '',
			country: `${config.globalOptions.MontenegroId}`,
			dial: config.adForm.addAdForm.dial,
			city: -1,
			location: -1,
			phone: '',
			code: ''
		}

		initialValues.existingUser = {
			dial: config.adForm.addAdForm.dial,
			phone: '',
			password: ''
		}
	}

	switch (currentSubCategory && currentSubCategory.requiredAdOptions) {
		case 'BrandModel':
			initialValues.brand = -1
			initialValues.product = -1
			break
		case 'BrandOnly':
			initialValues.brand = -1
			break
		case 'Services':
			initialValues.service = -1
			initialValues.serviceType = -1
			break
		default: break
	}

	if (currentSubCategory && currentSubCategory.condition) {
		initialValues.condition = conditions.USED.value
	}

	return initialValues
}